import { useState } from "react";

export default function PhotoWall() {
    const [url, setUrl] = useState("");
    setUrl("FT_photoswall");
    window.location.href = url;
    return (<template></template>);
}